module.exports = __webpack_public_path__ + "static/media/strongher12_preview.e89637c4.jpg";